import styled from 'styled-components';
import { DefaultTitleLargeFactory } from '../../../../../components/Habitacional/core/Typograph/Typograph.Style';

export const TitleForm = styled.h3(({ theme }) => ({
    ...DefaultTitleLargeFactory({ theme }),
    marginBottom: "32px",
}))

export const ContentTabsMIP = styled.div(() => ({
    marginTop: "60px",
}))

export const ContentFormMIP = styled.div(() => ({
    display: "grid",
    gap: "32px",
}))

export const TextError = styled.p(({ theme }) => ({
    color: theme.color.feedback.error
}))

export const ContentButton = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
    gap: "20px",
    alignSelf: "stretch",
}))

export const ErrorMessage = styled.h6(({ theme }) => ({
    textAlign: "inherit",
    display: "flex",
    alignItems: "center",
    svg: {
        margin: "0 5px 0 0",
        width: "1rem",
    },
    color: theme.color.feedback.error,
    marginTop: 0,
    marginBottom: 0,
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "150%",
}));
